import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatTableDataSource } from '@angular/material/table'
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-dialog-agregar-plato',
  templateUrl: './dialog-agregar-plato.component.html',
  styleUrls: ['./dialog-agregar-plato.component.scss']
})
export class DialogAgregarPlatoComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  isLoading: boolean = true

  myControl = new FormControl<string | any>('')
  dishes: any = []
  menuDishes: any = []
  displayedColumns = ['nombre', 'categoria', 'observaciones']
  filteredOptions$!: Observable<any[]>

  addedDishes: any[] = []
  dataSource = new MatTableDataSource(this.addedDishes)

  constructor (
    private readonly aybService: AyBService,
    public dialogRef: MatDialogRef<DialogAgregarPlatoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit (): void {
    console.log(this.myControl)
    this.getAllPlatos()

    this.getAllPlatosByMenuId()

    this.filteredOptions$ = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombrePlato =
          typeof value === 'string' ? value : value?.nombrePlato
        return nombrePlato
          ? this._filter(nombrePlato as string)
          : this.dishes.slice()
      })
    )
  }
  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }
  getAllPlatosByMenuId (): void {
    this.aybService
      .queryGetAllPlatosByMenuId({
        menuId: this.data?.id ?? ''
      })
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(({ getMenuById }) => {
        this.menuDishes = getMenuById.platos
        console.log({ menuDishes: this.menuDishes, getMenuById })
        if (this.menuDishes == null) {
          this.menuDishes = []
        }
      })
  }

  getAllPlatos () {
    this.aybService
      .queryGetAllPlatos()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(response => {
        this.dishes = response.getAllPlatos
        this.isLoading = false
      })
  }

  addPlatostoMenu () {
    if (this.addedDishes.length > 0) {
      const menu = {
        platos: this.menuDishes
      }

      console.log(this.menuDishes)

      this.aybService
        .mutationUpdatePlatosFromMenu({
          menuId: this.data.id,
          updatedMenu: menu
        })
        .subscribe({
          next: mutationUpdatePlatosFromMenu => {
            console.log({ mutationUpdatePlatosFromMenu })
            this.dialogRef.close(1)
          },
          error: err => {
            console.error(err)
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo actualizar el menú. Inténtalo de nuevo o contacta al soporte.'
            })
          }
        })
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        title: 'No ha agregado platos al menú',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000
      })
    }
  }

  private _filter (nombrePlato: string): any[] {
    const filterValue = nombrePlato.toLowerCase()

    return this.dishes.filter((option: { nombrePlato: string }) =>
      option.nombrePlato.toLowerCase().includes(filterValue)
    )
  }

  addDishSelection () {
    if (this.myControl.value) {
      console.log(this.myControl.value)
      const element = {
        id: this.myControl.value.id,
        nombrePlato: this.myControl.value.nombrePlato,
        categoria: this.myControl.value.categoria,
        observaciones: this.myControl.value.observaciones,
        costo: this.myControl.value.costo
      }

      this.addedDishes.push(this.myControl.value)
      this.menuDishes.push(this.myControl.value)

      this.myControl.reset()
      this.dataSource = new MatTableDataSource(this.addedDishes)
      return
    }

    console.log(this.myControl)
    Swal.fire({
      toast: true,
      position: 'top-end',
      title: 'Falta ingresar campos requeridos',
      icon: 'warning',
      showConfirmButton: false,
      timer: 3000
    })
  }

  getOptionText (option: any) {
    if (option && option.nombrePlato) {
      return option.nombrePlato
    } else {
      return ''
    }
  }
}
